import React, { useRef, lazy } from 'react';
import { ChevronLeft, ChevronRight, Utensils, Beef, Timer, Tag, Scale, Wallet, Users, TrendingUp, Pizza, FlameKindling } from 'lucide-react';
export function ContentPreview() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const contents = [{
    title: 'Las 10 recetas más vendidas del mercado artesanal argentino',
    icon: Utensils,
    color: 'from-spice-400 to-spice-600',
    image: 'https://cdn.magicpatterns.com/uploads/ug8Pw9eH4BrANj3T8Z3buG/Las_10_recetas_mas_vendidas_del_mercado_artesanal_argentino_.jpg'
  }, {
    title: 'Condimentos para carnes, pollo, pescado, pastas y línea fit/diet',
    icon: Beef,
    color: 'from-spice-500 to-spice-700',
    image: 'https://cdn.magicpatterns.com/uploads/9KMedc6sNBqLUFYikKZsih/Condimentos_para_carnes,_pollo,_pescado,_pastas_y_linea_fit_diet_.jpg'
  }, {
    title: 'Instrucciones de conservación y vida útil de cada preparación',
    icon: Timer,
    color: 'from-spice-400 to-spice-600',
    image: 'https://cdn.magicpatterns.com/uploads/3JnFvd3EnDeNNb7xjLyPHe/Instrucciones_de_conservacion_y_vida_util_de_cada_preparacion_.jpg'
  }, {
    title: 'Cómo etiquetar tus productos para que se vean profesionales',
    icon: Tag,
    color: 'from-spice-500 to-spice-700',
    image: 'https://cdn.magicpatterns.com/uploads/m5YCqUzS3EMQxArQYGV3ja/Como_etiquetar_tus_productos_para_que_se_vean_profesionales_.jpg'
  }, {
    title: 'Los ingredientes exactos con cantidades para escalar tu producción',
    icon: Scale,
    color: 'from-spice-400 to-spice-600',
    image: 'https://cdn.magicpatterns.com/uploads/e8uQ8yz1f3XvXTV12t3YcG/Los_ingredientes_exactos_con_cantidades_para_escalar_tu_produccion_.jpg'
  }, {
    title: 'Cómo armar tu primer lote vendible con menos de $5.000 de inversión',
    icon: Wallet,
    color: 'from-spice-500 to-spice-700',
    image: 'https://cdn.magicpatterns.com/uploads/uav4Xd1TuZQENGRXTqqYVj/Como_armar_tu_primer_lote_vendible_con_menos_de_5.000_de_inversion_.jpg'
  }, {
    title: 'El método para conseguir tu primer cliente en 24–48 horas',
    icon: Users,
    color: 'from-spice-400 to-spice-600',
    image: 'https://cdn.magicpatterns.com/uploads/dW3RZ9cNzZWXh3UcrSR4m5/El_metodo_para_conseguir_tu_primer_cliente_en_24–48_horas_.jpg'
  }, {
    title: 'Cómo fijar precios aunque los ingredientes suban cada semana',
    icon: TrendingUp,
    color: 'from-spice-500 to-spice-700'
  }, {
    title: 'Guía completa de condimentos italianos artesanales',
    icon: Pizza,
    color: 'from-spice-400 to-spice-600',
    image: 'https://cdn.magicpatterns.com/uploads/jtwnyWk72oBidCBwRfe5zn/bono_6.jpg'
  }, {
    title: 'Recetas de salsas gourmet con alto margen de ganancia',
    icon: FlameKindling,
    color: 'from-spice-500 to-spice-700',
    image: 'https://cdn.magicpatterns.com/uploads/8Dy2qXSmVogqPZBATphXQh/Recetas_de_salsas_gourmet_con_alto_margen_de_ganancia_.jpg'
  }];
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-12 md:py-20 px-4 bg-spice-50 border-y border-spice-200" data-id="element-58">
      <div className="max-w-6xl mx-auto" data-id="element-59">
        <div className="text-center mb-6 md:mb-10" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-61">
            Tipos de contenido Que vas a encontrar adentro
          </h2>
          <div className="w-24 h-1 bg-spice-400 mx-auto rounded-full" data-id="element-62"></div>
        </div>

        <div className="flex justify-end gap-2 mb-4 pr-2" data-id="element-63">
          <button onClick={() => scroll('left')} className="bg-white border border-spice-200 rounded-full p-2 shadow-sm transition-all hover:bg-spice-100 hover:scale-110" data-id="element-64">
            <ChevronLeft className="w-5 h-5 text-spice-700" data-id="element-65" />
          </button>
          <button onClick={() => scroll('right')} className="bg-white border border-spice-200 rounded-full p-2 shadow-sm transition-all hover:bg-spice-100 hover:scale-110" data-id="element-66">
            <ChevronRight className="w-5 h-5 text-spice-700" data-id="element-67" />
          </button>
        </div>

        <div ref={scrollRef} className="flex gap-3 md:gap-5 overflow-x-auto pb-6 snap-x snap-mandatory scrollbar-hide" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-68">
          {contents.map((item, index) => {
          const Icon = item.icon;
          return <div key={index} className="flex-shrink-0 w-64 md:w-72 snap-start bg-white rounded-2xl shadow-md border border-spice-100 overflow-hidden group" data-id="element-69">
                {item.image ? <div className="h-32 md:h-40 overflow-hidden" data-id="element-70">
                    <img src={item.image} alt={item.title} loading="lazy" className="w-full h-full object-cover" data-id="element-71" />
                  </div> : <div className={`h-32 md:h-40 bg-gradient-to-br ${item.color} flex items-center justify-center`} data-id="element-72">
                    <Icon className="w-16 h-16 text-white/80" data-id="element-73" />
                  </div>}
                <div className="p-3 md:p-5" data-id="element-74">
                  <p className="text-gray-800 font-semibold leading-snug" data-id="element-75">
                    {item.title}
                  </p>
                </div>
              </div>;
        })}
          <div className="flex-shrink-0 w-64 md:w-72 snap-start bg-spice-700 rounded-2xl shadow-md overflow-hidden flex items-center justify-center p-8" data-id="element-76">
            <p className="text-white text-2xl font-heading font-bold text-center" data-id="element-77">
              ¡Y mucho más!
            </p>
          </div>
        </div>
      </div>
    </section>;
}